const messages = {
    us: {
        // lp = landing page
        lp: {
            welcome: 'Welcome',
            desc: 'Do you have the eye of an expert?',
            verify_button: 'Authenticate your certificate',
        },
        footer: {
            powered_by: 'Powered By',
            all_right_reserved: 'All Rights Reserved'
        },
        verify: {
            title_p1: 'You are about to verify a certificate',
            content_p1: 'You can find the QR code on the certificate',
            button_p1: 'Scan now',
            title_p2: 'Scan the certificate’s QR Code',
            content_p2: 'Place the code in the center of the square <br /> it will be scanned automatically',
            button_p2: 'I want to enter the certificate address instead',
            title_p3: 'You are about to authenticate a certificate',
            content_p3: 'Enter Certificate Address',
            button_p3: 'Verify now',
            title_p4: 'You found a counterfeit certificate',
            // tslint:disable-next-line: max-line-length
            content_p4: 'You just found a suspected counterfeit certificate. You can help us by reporting the details of this certificate.',
            button1_p4: 'Ok',
            button2_p4: 'Report'
        },
        report: {
            title: 'Report',
            field1: 'Student Name',
            field2: 'Programme',
            field3: 'E-mail',
            agree: 'I agree to the terms and condition',
            term_and_condition: 'the terms and condition',
            button: 'Report'
        },
        certificate: {
            home: 'Home',
            certificate: 'Certificate',
            university: 'University',
            details: 'Details',
            discover: 'Discover',
            issuer: 'Issuer',
            verified_by_blockchain: 'Verified by Blockchain',
            verified: 'Verified',
            not_verified: 'Not Verified',
            iium: 'International Islamic University Malaysia',
            dora: 'docuTag',
            // tslint:disable-next-line: max-line-length
            iium_desc: 'The International Islamic University Malaysia, also known as IIUM, is a public university in Malaysia.',
            dora_desc: 'docuTag is secured and verified using blockchain technology',
            MATRIC_NO: 'MATRIC NO',
            NAME: 'NAME',
            KULLIYYAH: 'KULLIYYAH',
            KULY_DESC: 'KULY DESC',
            PROGRAMME: 'PROGRAMME',
            DATE_ENDORSE: 'DATE ENDORSE',
            SERIAL_NO: 'SERIAL NO',
            CITIZENSHIP: 'CITIZENSHIP'
        }
    },
    my: {
        lp: {
            welcome: 'Selamat Datang',
            desc: 'Adakah anda mempunyai mata pakar?',
            verify_button: 'Sahkan ijazah anda'
        },
        footer: {
            powered_by: 'Dikuasai oleh',
            all_right_reserved: 'Hak cipta terpelihara'
        },
        verify: {
            title_p1: 'Anda akan mengesahkan sijil akademik',
            content_p1: 'Anda boleh mendapatkan kod QR di peringkat ijazah',
            button_p1: 'Mengimbas sekarang',
            title_p2: 'Imbas Kod QR sijil',
            content_p2: 'Letakkan kod di tengah petak <br /> itu akan diimbas secara automatik',
            button_p2: 'Saya mahu memasukkan ID sijil akademik',
            title_p3: 'Anda akan mengesahkan sijil akademik',
            content_p3: 'Masukkan ID Sijil Akademik',
            button_p3: 'Perakui sekarang',
            title_p4: 'Anda menemui ijazah palsu',
            // tslint:disable-next-line: max-line-length
            content_p4: 'Anda baru menjumpai diploma palsu yang disyaki. Anda boleh membantu kami dengan melaporkan perincian diploma ini.',
            button1_p4: 'Okey',
            button2_p4: 'Lapor'
        },
        report: {
            title: 'Lapor',
            field1: 'Nama pelajar',
            field2: 'Program',
            field3: 'E-mel',
            agree: 'Saya bersetuju dengan',
            term_and_condition: 'terma dan syarat',
            button: 'Lapor'
        },
        certificate: {
            home: 'Rumah',
            certificate: 'Sijil',
            university: 'Universiti',
            discover: 'Cari',
            issuer: 'Penerbit',
            verified_by_blockchain: 'Disahkan oleh Blockchain',
            verified: 'Disahkan',
            not_verified: 'Tidak disahkan',
            iium: 'International Islamic University Malaysia',
            // tslint:disable-next-line: max-line-length
            iium_desc: 'The International Islamic University Malaysia, also known as IIUM, is a public university in Malaysia.',
            MATRIC_NO: 'MATRIC NO',
            NAME: 'NAMA',
            KULLIYYAH: 'KULLIYYAH',
            KULY_DESC: 'KULY DESC',
            PROGRAMME: 'PROGRAM',
            DATE_ENDORSE: 'TARIKH AKHIR',
            SERIAL_NO: 'SIRI NO',
            CITIZENSHIP: 'KEWARGANEGARAAN'
        }
    }
};

export default messages;
